<div *ngIf="isloaded">
  <ebb-training  [trainingType]="trainingType" [currentUser]="currentUser"></ebb-training>
</div>
